import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { LookupModel } from '../../common/models/LookupModel';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'brd-extract-filter-dialog',
  templateUrl: './extract-filter-dialog.component.html',
  styleUrls: ['./extract-filter-dialog.component.scss']
})
export class ExtractFilterDialogComponent implements OnInit {
  filterForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ExtractFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private formBuilder: FormBuilder
  ) {
    var model = this.data.model;
    if (model == null) {
      this.filterForm = this.formBuilder.group({
        fsn: [''],
        providersParticipantIdentifier: [''],
        providerId: [''],
        clientFirstName: [''],
        clientLastName: [''],
        submittedToCalOMS: null
      });
    } else {
      this.filterForm = this.formBuilder.group({
        fsn: [model.fsn],
        providersParticipantIdentifier: [model.providersParticipantIdentifier],
        providerId: [model.providerId],
        clientFirstName: [model.clientFirstName],
        clientLastName: [model.clientLastName],
        submittedToCalOMS: model.submittedToCalOMS
      });
    }
  }

  ngOnInit() {
  }

  search(): void {
    this.dialogRef.close(this.filterForm.value);
  }
}




// WEBPACK FOOTER //
// ./src/app/extracts/components/extract-filter-dialog.component.ts